
import React, { Component } from 'react';
import { Select } from 'antd';
const Option = Select.Option;
class SchoolSelect extends Component {
    onSelectChange = (orgId) => {
        sessionStorage.setItem('orgId', orgId)
        this.props.onSelectChange && this.props.onSelectChange(orgId)
    }

    render() {
        const { orgList, style } = this.props
        return <Select style={style} onChange={this.onSelectChange} defaultValue={window.sessionStorage.getItem('orgId') || "请选择"}>
            {
                orgList.map((item) => {
                    return <Option key={item.code} value={item.id}>{item.name}</Option>
                })
            }
        </Select>
    }
}
export default SchoolSelect


// WEBPACK FOOTER //
// ./src/components/SchoolSelect/index.jsx